import { render, staticRenderFns } from "./TheMenuLayout.vue?vue&type=template&id=13de8aa7&"
import script from "./TheMenuLayout.vue?vue&type=script&lang=js&"
export * from "./TheMenuLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports